import React, { useContext, useState } from "react";
import { Button } from "@windmill/react-ui";
import { useDispatch } from "react-redux";
import "./ProfilePage.css";
import { updateUser } from "../../../Redux/userReducer";
import { useSelector } from "react-redux/es/exports";
import LabelArea from "../../../operator/components/form/LabelArea";
import Form from 'react-bootstrap/Form';

import InputArea from "../../../operator/components/form/InputArea";

import PageTitle from "../../../operator/components/Typography/PageTitle";

import { getUser } from "../../../Redux/userReducer";
import { useEffect } from "react";

const ProfilePage = () => {
  const dispatch = useDispatch();
  // const userData =useSelector((state)=>state?.userReducer?.userdataOperator?.user); 
  const userData = useSelector((state) => state?.userReducer?.userData?.user);
  const loggedUser = useSelector((state) => state?.userReducer?.userdataOperator?.user);
  const userId = useSelector((state) => state?.userReducer?.userdataOperator?.user?._id);




  const [user, setUser] = useState({
    username: loggedUser?.username || "",
    gender: loggedUser?.gender || "Male",
    phone: loggedUser?.phone || "",
    email: loggedUser?.email || "",
    address: loggedUser?.address || "",
  });
  const [selectedImage, setSelectedImage] = useState(null);


  console.log("userDatauserData", user);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };


  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
    }
  };
  const handleGenderChange = (e) => {
    setUser((prevUser) => ({
      ...prevUser,
      gender: e.target.value,
    }));
  };
  console.log("user", user);

  const submitUpdate = (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append("username", user.username);
    data.append("gender", user.gender);
    data.append("phone", user.phone);
    data.append("email", user.email);
    data.append("address", user.address);
    if (selectedImage) {
      data.append("image", selectedImage);
    }

    dispatch(updateUser({ userData: data, userId }));
  };



  useEffect(() => {
    dispatch(getUser());

  }, []);
  return (
    <>
      <div className="topHeaderPG">
        <PageTitle className="headerText">Edit Profile</PageTitle>
      </div>
      <div className="container p-6 mx-auto bg-white rounded-lg">
        <form>
          <div className="p-6 flex-grow scrollbar-hide w-full max-h-full">
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Profile Picture" />
              <div className="col-span-8 sm:col-span-4">
                <label className="upload">
                  <input
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    className="userProfileImageSelect"
                  // Hide the input
                  />
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Selected"
                      style={{ width: "70px", height: "70px", borderRadius: "50%", objectFit: "cover" }}
                    />
                  ) : (
                    <>
                      Click<br />here
                    </>
                  )}
                </label>
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Name" />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  label="User Name"

                  name="username"

                  defaultValue={user.username}

                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder="Username"
                />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Gender" />
              <div className="col-span-8 sm:col-span-4">
                <Form.Select size="lg" className="genderSelect"
                  value={user.gender}
                  onChange={handleGenderChange}
                >
                  <option>Male</option>
                  <option>Female</option>
                  <option>Others</option>
                </Form.Select>
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Contact Number" />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  label="Contact Number"
                  name="phone"
                  defaultValue={user.phone}
                  onChange={(e) => handleChange(e)}
                  type="text"
                  placeholder="Phone"
                />
              </div>
            </div>
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Email" />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  label="Email"
                  defaultValue={user.email}
                  onChange={(e) => handleChange(e)}
                  name="email"
                  type="text"
                  placeholder="Email"
                />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="Country & City" />
              <div className="col-span-8 sm:col-span-4">
                {/* <SelectRole register={register} label="Role" name="role" /> */}

                <InputArea
                  label="Country & City"
                  name="address"
                  type="text"
                  defaultValue={user.address}
                  onChange={(e) => handleChange(e)}
                  placeholder="Country & City"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-row-reverse pr-6 pb-6">
            <Button
              type="submit"
              className="h-12 px-6 updateProfileBtn"
              onClick={submitUpdate}
            >
              {" "}
              Update Profile
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ProfilePage;
